import React, { forwardRef } from 'react';
import styled from 'styled-components';
import FilterSelect, { FilterSelectIcon } from './FilterSelect';
import SearchMapImage from '../../../images/front/search/search_map.png';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { FilterSelectProps } from './FilterSelect';

const LabelWrapper = styled.div<{ withPortal?: boolean }>`
  width: 100%;
  height: 100%;

  ${({ withPortal }) =>
    withPortal &&
    `
      position: relative;
      left: -12px;
      height: 100%;
    `}
`;

const useStyles = makeStyles((theme) => ({
  icon: {
    [theme.breakpoints.down('xs')]: {
      width: '28px',
      height: '100%',
    },
  },
}));

type RegionSelectProps = Pick<
  FilterSelectProps,
  'label' | 'name' | 'value' | 'onChange' | 'onClose' | 'multiple'
> & {
  withPortal?: boolean;
  regions?: Array<{ id: number; name: string }>;
};

const RegionSelect = forwardRef(
  (
    {
      regions,
      label,
      name,
      value,
      onChange,
      multiple,
      onClose,
      withPortal,
    }: RegionSelectProps,
    ref,
  ) => {
    const classes = useStyles();

    return (
      <FilterSelect
        choices={regions?.map(({ id, name }) => ({
          text: name,
          value: id,
        }))}
        label={
          <LabelWrapper withPortal={withPortal}>
            <FilterSelectIcon
              src={SearchMapImage}
              className={classes.icon}
              alt={T.translate('plan.regionSelect') as string}
            />
            {label}
          </LabelWrapper>
        }
        name={name}
        value={value}
        multiple={multiple}
        onChange={onChange}
        onClose={onClose}
        ref={ref}
      />
    );
  },
);

export default RegionSelect;
